<div class="phone-input-container">
  <form [formGroup]="phoneForm">
    <nz-form-item>
      <nz-form-label *ngIf="label">{{label}}</nz-form-label>
      <div nz-row >
        <div nz-col [nzSpan]="8">
          <nz-form-control class="padding-right-1">
            <nz-select formControlName="phoneCountryCode" nzShowSearch nzPlaceHolder="Country code" id="phoneCountryCode" data-testid="phoneCountryCode">
              <nz-option *ngFor="let code of countryPhoneCodes" 
                        [nzValue]="code.iso" 
                        [nzLabel]="code.label">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </div>
        <div nz-col [nzSpan]="16">
          <nz-form-control [nzErrorTip]="phoneErrorTpl">
            <input nz-input [placeholder]="placeholder" formControlName="phone" id="phoneNumber" data-testid="phoneNumber" autocomplete="off">
          </nz-form-control>
        </div>
      </div>
    </nz-form-item>
  </form>
</div> 


<ng-template #phoneErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">
    Phone number is required
  </ng-container>
  <ng-container *ngIf="control.hasError('hasSpaces')">
    Phone number should not contain spaces
  </ng-container>
  <ng-container *ngIf="control.hasError('tooShort')">
    Phone number too short for selected country code
  </ng-container>
  <ng-container *ngIf="control.hasError('tooLong')">
    Phone number too long for selected country code
  </ng-container>
  <ng-container *ngIf="control.hasError('invalidCharacters')">
    Phone number should contain only digits
  </ng-container>
  <ng-container *ngIf="control.hasError('invalidPhone') && !control.hasError('tooShort') && !control.hasError('tooLong') && !control.hasError('hasSpaces') && !control.hasError('invalidCharacters')">
    Invalid phone number for selected country code
  </ng-container>
</ng-template>